(function(){
  function ready(fn){ if(document.readyState!=='loading'){ fn(); } else { document.addEventListener('DOMContentLoaded', fn); } }

  function getContainer(){ return document.getElementById('sticky-subscription-bar'); }

  function clickThemeBlockForOption(select, scope){
    var idx = select.selectedIndex;
    var blocks = scope.querySelectorAll('.choosesubscriptionproducts .single_product');
    var opt = select.options[idx];
    var planId = opt.getAttribute('data-plan-id') || '';
    var productId = opt.getAttribute('data-product-id') || '';
    var variantId = opt.getAttribute('data-variant-id') || '';
    var targetBlock;
    blocks.forEach(function(block){
      var inner = block.querySelector('.selling_plan_vavaverve');
      if(!inner) return;
      var matchesPlan = (planId === '' && !inner.getAttribute('data-selling-plan-id')) || (String(inner.getAttribute('data-selling-plan-id')) === String(planId));
      var matchesProduct = String(inner.getAttribute('data-product-id')) === String(productId);
      var matchesVariant = String(inner.getAttribute('data-variant-id')) === String(variantId);
      if((planId === '' && matchesVariant) || (matchesPlan && matchesProduct && matchesVariant)){
        targetBlock = block;
      }
    });
    if(targetBlock){ targetBlock.click(); }
  }

  function triggerThemeAddToCart(scope){
    var btn = scope.querySelector('.product-form__submit');
    if(btn){ btn.click(); }
  }

  ready(function(){
    var container = getContainer();
    if(!container) return;
    var sectionId = container.getAttribute('data-section-id');
    var scope = document.getElementById('ProductInfo-' + sectionId) || document;

    var select = document.getElementById('ssb-purchase-select');
    var button = document.getElementById('ssb-add-to-cart');

    if(select){
      select.addEventListener('change', function(){
        clickThemeBlockForOption(select, scope);
      });
    }

    if(button){
      button.addEventListener('click', function(){
        if(select){ clickThemeBlockForOption(select, scope); }
        triggerThemeAddToCart(scope);
      });
    }

    // Find the add to cart button
    var addToCartButton = scope.querySelector('.product-form__submit');
    if(addToCartButton){
      // Ensure hidden on load
      container.classList.remove('visible');
      
      var io = new IntersectionObserver(function(entries){
        entries.forEach(function(entry){
          // Show sticky bar only when button is NOT visible (scrolled past it)
          if(entry.isIntersecting){
            container.classList.remove('visible');
          } else {
            // Only add visible if we've scrolled past (button is above viewport)
            var rect = addToCartButton.getBoundingClientRect();
            if(rect.bottom < 0){
              container.classList.add('visible');
            }
          }
        });
      }, { root: null, threshold: 0, rootMargin: '0px' });
      io.observe(addToCartButton);

      // Scroll fallback in case IO is blocked
      var ticking = false;
      function onScroll(){
        if(ticking) return; ticking = true;
        requestAnimationFrame(function(){
          try {
            var rect = addToCartButton.getBoundingClientRect();
            // Only show sticky bar when button has scrolled above viewport
            if(rect.bottom < 0){ 
              container.classList.add('visible'); 
            } else { 
              container.classList.remove('visible'); 
            }
          } catch(e) {}
          ticking = false;
        });
      }
      window.addEventListener('scroll', onScroll, { passive: true });
    } else {
      container.classList.add('visible');
    }
  });
})();